import { createSlice } from '@reduxjs/toolkit'

const reply = createSlice({
    name: 'reply',
    initialState: {
        username: null,
        createdAt: null,


        age: null,
        gender: null,
        diabetesType: null,
        q1: null,
        diagnosisYear: null,
        q2: null,
        q3: null,
        q4: null,
        q5: null,
        q6: null,
        q7: null,
        q8: null,
        q9: null,
        qA1: null,
        qA2: null,
        qA3: null,
        qA4r: null,
        qA5r: null,
        qA6r: null,
        qA7r: null,
        qA8r: null,
        qA9r: null,
        qA10r: null,
        qA11r: null,
        qA12r: null,
        qA13r: null,
        qA14r: null,
        qA15: null,
        qA16: null,
        qA17: null,
        qA18: null,
        qA19: null,
        qA20: null,
        qA21: null,
        qA22: null,
        qA23: null,

        isSubmitted: false,
        patientData: []

        

    },
    reducers: {
        setUsername: (store, action) => {
            store.username = action.payload
        },

        setCreatedAt: (store, action) => {
            store.createdAt = action.payload
        },
        


        setAge: (store, action) => {
            store.age = action.payload
        },
        setGender: (store, action) => {
            store.gender = action.payload
        },
        setDiabetesType: (store, action) => {
            store.diabetesType = action.payload
        },
        setQ1: (store, action) => {
            store.q1 = action.payload
        },
        setDiagnosisYear: (store, action) => {
            store.diagnosisYear = action.payload
        },
        setQ2: (store, action) => {
            store.q2 = action.payload
        },
        setQ3: (store, action) => {
            store.q3 = action.payload
        },
        setQ4: (store, action) => {
            store.q4 = action.payload
        },
        setQ5: (store, action) => {
            store.q5 = action.payload
        },
        setQ6: (store, action) => {
            store.q6 = action.payload
        },
        setQ7: (store, action) => {
            store.q7 = action.payload
        },
        setQ8: (store, action) => {
            store.q8 = action.payload
        },

        setQ9: (store, action) => {
            store.q9 = action.payload
        },

        setQA1: (store, action) => {
            store.qA1 = action.payload
        },
        setQA2: (store, action) => {
            store.qA2 = action.payload
        },
        setQA3: (store, action) => {
            store.qA3 = action.payload
        },
        setQA4r: (store, action) => {
            store.qA4r = action.payload
        },
        setQA5r: (store, action) => {
            store.qA5r = action.payload
        },
        setQA6r: (store, action) => {
            store.qA6r = action.payload
        },
        setQA7r: (store, action) => {
            store.qA7r = action.payload
        },
        setQA8r: (store, action) => {
            store.qA8r = action.payload
        },
        setQA9r: (store, action) => {
            store.qA9r = action.payload
        },
        setQA10r: (store, action) => {
            store.qA10r = action.payload
        },
        setQA11r: (store, action) => {
            store.qA11r = action.payload
        },
        setQA12r: (store, action) => {
            store.qA12r = action.payload
        },
        setQA13r: (store, action) => {
            store.qA13r = action.payload
        },
        setQA14r: (store, action) => {
            store.qA14r = action.payload
        },
        setQA15: (store, action) => {
            store.qA15 = action.payload
        },
        setQA16: (store, action) => {
            store.qA16 = action.payload
        },
        setQA17: (store, action) => {
            store.qA17 = action.payload
        },
        setQA18: (store, action) => {
            store.qA18 = action.payload
        },
        setQA19: (store, action) => {
            store.qA19 = action.payload
        },
        setQA20: (store, action) => {
            store.qA20 = action.payload
        },
        setQA21: (store, action) => {
            store.qA21 = action.payload
        },
        setQA22: (store, action) => {
            store.qA22 = action.payload
        },
        setQA23: (store, action) => {
            store.qA23 = action.payload
        },

        setIsSubmitted: (store, action) => {
            store.isSubmitted = action.payload
        },
        setPatientData: (store, action) => {
            store.patientData = action.payload
          }

        // setErrors: (store, action) => {
        //     store.errors = action.payload
        //   }

        
    }
})


export default reply